import React, { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { IconLookup } from '@fortawesome/pro-regular-svg-icons';
import './SideNavigationMenu.scss';
import { Button, Icon, Tooltip } from '@innovationnorway/cl-react';
import { useTranslation } from 'react-i18next';
import Divider from 'src/components/Divider';
type SideNavigationMenuProps = {
  backButtonPath?: string;
  routerLinks: RouterLinks[];
  className?: string;
  collapsable?: boolean;
};
export type RouterLinks = {
  id: number;
  isVisible: boolean;
  to: string;
  icon?: IconLookup;
  textContent: string;
  exact?: boolean;
  state?: {
    [key: string]: string;
  };
};
const SideNavigationMenu: React.FC<SideNavigationMenuProps> = ({
  backButtonPath,
  routerLinks,
  className,
  collapsable = true,
}) => {
  const { t: tCommon } = useTranslation();
  const [show, setShow] = useState(true);

  // Labels are visible when expanded, so tooltips are only needed in the collapsed state
  const withTooltip = (content: string, child: React.ReactElement) =>
    show ? (
      child
    ) : (
      <Tooltip content={content} placement="right">
        {child}
      </Tooltip>
    );

  return (
    <aside className={`side-navigation-menu ${className || ''}`}>
      <nav className="side-navigation-menu__buttons center stack-medium padding-top--2">
        {backButtonPath && (
          <Link to={backButtonPath} className={`${show ? 'text-align--left' : ''} margin-bottom--6`}>
            <div>
              <Icon prefix="fasr" iconName="arrow-left" className="margin-right--1" />{' '}
              {show && <u>{tCommon('back')}</u>}
            </div>
          </Link>
        )}

        {routerLinks.map((routerLink) => {
          if (routerLink.isVisible) {
            return (
              <React.Fragment key={routerLink.id}>
                {withTooltip(
                  routerLink.textContent,
                  <NavLink
                    to={routerLink.to}
                    end={routerLink.exact}
                    className={`${show ? 'text-align--left' : ''} display--flex`}
                    state={routerLink.state}
                  >
                    {routerLink.icon !== undefined && (
                      <div className={`margin-y--auto ${!show && 'margin-x--auto'}`}>
                        <Icon
                          prefix={routerLink.icon.prefix === 'fas' ? 'fass' : 'fasr'}
                          iconName={routerLink.icon.iconName}
                          size="m"
                          className="vertical-align--icon align-self--baseline"
                        />
                      </div>
                    )}
                    {show && <span className="">{routerLink.textContent}</span>}
                  </NavLink>,
                )}
              </React.Fragment>
            );
          }
        })}
        {collapsable && (
          <>
            <Divider className="margin-top--3" />
            {withTooltip(
              tCommon('showMore'),
              <Button
                type="button"
                variant="tertiary"
                onClick={() => setShow(!show)}
                className={show ? 'open' : ''}
              >
                <Icon prefix="fasr" iconName={show ? 'angle-double-left' : 'angle-double-right'} />
                {show && tCommon('showLess')}
              </Button>,
            )}
          </>
        )}
      </nav>
    </aside>
  );
};
export default SideNavigationMenu;
